import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import * as api from './api';

import { AuthStateData } from './types';

const initialState: AuthStateData = {
	data: {
		data: { session_id: '', author_id: '', expire_dt: '', refresh_id: '' },
		error: null,
		message: null,
	},
	loading: false,
	error: '',
	isAuth: false,
	role: null,
	initialized: false,
};

export const fetchAuth = createAsyncThunk(
	'api/fetchAuth',
	({ username, password, authEndpoint }: { username: string; password: string; authEndpoint: string }) =>
		api.fetchAuth({ username, password, authEndpoint }),
);

const authSlice = createSlice({
	name: 'auth',
	initialState,
	reducers: {
		setAuth: (state, action) => {
			state.isAuth = true;
			state.role = action.payload.role;
			state.initialized = true;
		},
		setInitialized: (state) => {
			state.initialized = true;
		},
		clearAuth: (state) => {
			state.isAuth = false;
			state.role = null;
			state.data = initialState.data;
		},
	},
	extraReducers(builder) {
		builder
			.addCase(fetchAuth.pending, (state) => {
				state.loading = true;
			})
			.addCase(fetchAuth.fulfilled, (state, action) => {
				state.loading = false;
				state.data = action.payload || {};
				state.error = '';

				if (action.payload?.data?.session_id) {
					state.isAuth = true;
					state.role = action.payload.role || 'user';
				}
			})
			.addCase(fetchAuth.rejected, (state, action) => {
				state.loading = false;
				state.error = action.error.message || 'Ошибка загрузки данных';
			});
	},
});

export const { setAuth, clearAuth, setInitialized } = authSlice.actions;
export default authSlice.reducer;
